import Vue from 'vue';
import { apolloProvider } from '@/graphql/vueApollo'; // GraphQL connection
import logger from 'client-logger';

// Our queries and mutations
import PURGE_CACHE from '@/graphql/mutations/purgeCache.gql';

// Error Handling
import AppState from '@/store/AppState';

const apollo = apolloProvider.defaultClient;

// An interface for getting, querying, and mutating our data.
const System = new Vue({
	methods: {
		// Purges the Redis cache on the server
		async purgeCache(userJson) {
			try {
				const {
					data: { purgeCache: response }
				} = await apollo.mutate({
					mutation: PURGE_CACHE
				});

				return {
					data: response
				};
			} catch (e) {
				// Returns a nicely formatted GraphQL error object. Cheers!
				const formattedError = AppState.showGeneralError(e);
				logger.error({ error: (formattedError && formattedError.error) || e, userJson }, 'Error trying to purge cache');

				return formattedError;
			}
		}
	}
});

export default System;
